var angular = require("angular");
var amt_admin = require("amt_admin").default;
var app = angular.module("ww2_analytics.admin_tasks", [amt_admin]);

var main_tpl = require("./main.html");

app.service("admin_tasks_api", [
    "jsonrpc",
    function (jsonrpc) {
        var service = jsonrpc.newService("admin_tasks");

        this.run_tasks = service.createMethod("run_tasks");
    }
]);

app.config([
  "$stateProvider",
  function($stateProvider) {
    $stateProvider.state("amt.ww2.admin.task_list", {
      url: "/periodic_tasks",
      template: main_tpl,
      data: {
        priority: 103,
        title: "Periodic tasks",
        role: "admin",
        hidden_filters: true
      },
      controller: [
        "$scope",
        "$stateParams",
        "admin_tasks_api",
        function ($scope, $stateParams, admin_tasks_api) {
          $scope.tasks = [
            { title: "Update installs", cmd: "update_install_task" },
            { title: "Update purchase", cmd: "update_purchase_task" },
            { title: "Update DAO", cmd: "update_dao_task" },
            { title: "Update WAO", cmd: "update_wao_task" },
            { title: "Update MAO", cmd: "update_mao_task" }
          ];
          $scope.run_task = function(task_cmd) {
              console.log(task_cmd);
              admin_tasks_api
                  .run_tasks({task_name: task_cmd})
                .then(function(resp){

                });
          }
        }
      ]
    });
  }
]);

export default app.name;
